import React from "react";
import { Link } from "react-router-dom";
import MarqueeTags from "./MarqueeTags";

export default function Partenaires() {
  return (
    <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
          Découvrez nos commerçants partenaires à Claix
        </h2>
        <p className="mt-4 text-[15px] sm:text-base text-neutral-600 leading-relaxed">
          L'association PACTE réunit les commerces du centre-bourg et de Pont-Rouge pour dynamiser l’économie locale. Boulangerie, restaurants, artisans, boutiques… retrouvez des adresses authentiques et profitez d’offres exclusives grâce à notre application. Soutenir vos commerçants, c’est faire vivre Claix !
        </p>
      </div>

    <MarqueeTags className="" />

      <div className="mt-16 sm:mt-20 flex items-center justify-center gap-5 sm:gap-7">
        <Link
          to="https://download.pacte-claix.fr"
          className="inline-flex items-center justify-center rounded-full bg-black text-white
                             px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                             hover:opacity-90 transition"
        >
          En savoir plus
        </Link>

        <Link
          to="/devenir-partenaire"
          className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                            px-6 py-3 text-sm font-medium
                            s shadow-[0_4px_4px_rgba(0,0,0,0.25),_inset_0_0_10px_rgba(0,0,0,0.2)]
                            hover:bg-white/95 transition"
        >
          Devenir partenaire
        </Link>
      </div>
    </section>
  );
}